export var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus[ShipmentStatus["Pending"] = 1] = "Pending";
    ShipmentStatus[ShipmentStatus["Completed"] = 2] = "Completed";
    ShipmentStatus[ShipmentStatus["Posted"] = 3] = "Posted";
    ShipmentStatus[ShipmentStatus["Assigned"] = 4] = "Assigned";
    ShipmentStatus[ShipmentStatus["Delivered"] = 5] = "Delivered";
    ShipmentStatus[ShipmentStatus["Incomplete"] = 6] = "Incomplete";
})(ShipmentStatus || (ShipmentStatus = {}));
